import React from "react";
import strings from "../lang/Localiz";
import { useProgress } from "@react-three/drei";

function Loader() {
  const { progress } = useProgress();
  return (
    <div className="game-canvas-span">
      <div className="loading-animation">
        <figure>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </figure>
      </div>
      <span>{strings.load}</span>
      <div className="loading-progress">
        <div style={{ width: `${progress}%` }} className="loading-inner"></div>
      </div>
    </div>
  );
}

export default Loader;
